import type { PDFPageProxy, RenderTask } from 'pdfjs-dist';

export type RenderHandle = {
  promise: Promise<{ cssWidth: number; cssHeight: number }>;
  cancel: () => void;
};

export function renderPdfPage(
  page: PDFPageProxy,
  canvas: HTMLCanvasElement,
  cssScale: number
): RenderHandle {
  const dpr = window.devicePixelRatio || 1;
  const baseViewport = page.getViewport({ scale: 1 });
  const viewport = page.getViewport({ scale: cssScale * dpr });

  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  const cssWidth = Math.floor(baseViewport.width * cssScale);
  const cssHeight = Math.floor(baseViewport.height * cssScale);
  canvas.style.width = cssWidth + 'px';
  canvas.style.height = cssHeight + 'px';

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return {
      promise: Promise.reject(new Error('canvas 2d context unavailable')),
      cancel: () => {},
    };
  }

  // pdfjs 6+: параметр canvas обязателен (раньше в 4.x ломал рендер, теперь наоборот нужен).
  // intent: 'print' иногда даёт более качественный font rendering для сложных embedded шрифтов
  const task: RenderTask = page.render({
    canvasContext: ctx,
    viewport,
    canvas,
    intent: 'print',
  } as Parameters<PDFPageProxy['render']>[0]);

  return {
    promise: task.promise.then(() => ({ cssWidth, cssHeight })),
    cancel: () => {
      try {
        task.cancel();
      } catch {
        /* noop */
      }
    },
  };
}
